export enum AppRouteSegment {
  Root = '',
  ExternalPayment = 'external-payment',
  ExternalPaymentReservationDetails = 'reservation-details',
  ExternalPaymentPayment = 'payment',
  ExternalPaymentLinkExpired = 'external-payment-link-expired',
  ExternalPaymentCompleted = 'external-payment-completed',
  ExternalPaymentError = 'external-payment-error',
  ExternalDeskCheckInReservationPreview = 'external-desk/check-in-reservation-preview',
}

const buildRoute = (...segments: string[]): string =>
  `/${segments.join('/')}`;

export const AppRoute = {
  ExternalPaymentPayment: buildRoute(AppRouteSegment.ExternalPayment, AppRouteSegment.ExternalPaymentPayment),
  ExternalPaymentLinkExpired: buildRoute(AppRouteSegment.ExternalPayment, AppRouteSegment.ExternalPaymentLinkExpired),
  ExternalPaymentCompleted: buildRoute(AppRouteSegment.ExternalPayment, AppRouteSegment.ExternalPaymentCompleted),
  ExternalPaymentError: buildRoute(AppRouteSegment.ExternalPayment, AppRouteSegment.ExternalPaymentError),
  CheckInCompleted: '/check-in-completed',
  EarlyCheckInDriverDetails: '/early-check-in/driver-details',
  ExternalDeskCheckInReservationPreview: buildRoute(AppRouteSegment.ExternalDeskCheckInReservationPreview),
} as const;

export type AppRoute = (typeof AppRoute)[keyof typeof AppRoute];

export enum RouteQueryParam {
  DeskId = 'deskId',
  EntityId = 'entityId',
  Error = 'error',
  IsConfirmationMode = 'isConfirmationMode',
  ProcessId = 'processId',
  Token = 'token',
  Url = 'url',
}

export function buildExternalDeskCheckInReservationPreviewUrl(
  appBaseExternalUrl: string,
  processId?: string,
  token?: string
) {
  const params = new URLSearchParams();
  if (processId) {
    params.set(RouteQueryParam.ProcessId, processId);
  }
  if (token) {
    params.set(RouteQueryParam.Token, token);
  }

  const basePath = `${appBaseExternalUrl}${AppRoute.ExternalDeskCheckInReservationPreview}`;
  const query = params.toString();
  return query ? `${basePath}?${query}` : basePath;
}